import React from 'react';
import './BuyOrSwap.css';
import buyOrSwapImage from '../images/buy-or-swap-image.png';

const BuyOrSwap = () => {
    return (
        <section className="buy-or-swap">
            <div className="buy-or-swap-container">
                <div className="buy-or-swap-content">
                    <h2>Buy or swap crypto at competitive rates. Every time.</h2>
                    <p>We compare offers from the best providers so you always get the most crypto for your money, with transparent pricing and multiple payment options.</p>
                    <div>
                        <button>Buy Crypto</button>
                        <button className="secondary">Swap Crypto</button>
                    </div>
                </div>
                <div className="buy-or-swap-image">
                    <img src={buyOrSwapImage} alt="Buy or Swap" />
                </div>
            </div>
        </section>
    );
};

export default BuyOrSwap;